import React from 'react';
import { ControlProps } from 'react-select';
import classNames from 'classnames';

import { InputClassProps } from '../../input-class-name.util';
import { Option } from '../option.model';

export const Control = ({
  children,
  innerRef,
  innerProps,
  hasError,
  variant,
  fullWidth,
  isFocused,
}: ControlProps<Option, true> & InputClassProps) => (
  <div
    ref={innerRef}
    className={classNames(
      'control flex items-center justify-between flex-wrap cursor-default relative border rounded focus:outline-none placeholder-primary-300',
      {
        'bg-primary-25': variant === 'default',
        'bg-white': variant === 'white',
        'w-full': fullWidth,
        'border-red-500': hasError,
        'border-primary-150': !hasError,
        'shadow-primary-500': isFocused && !hasError,
        'ring-1 ring-red-500': isFocused && hasError,
      }
    )}
    {...innerProps}
  >
    {children}
  </div>
);
